import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d0e36d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = {
  key: 0,
  class: "header-not-sign-in"
}
const _hoisted_3 = { class: "lang-wrap" }
const _hoisted_4 = {
  key: 1,
  class: "header-sign-in"
}
const _hoisted_5 = { class: "settings-wrap" }
const _hoisted_6 = {
  key: 0,
  class: "user-names"
}
const _hoisted_7 = { class: "user-name-wrap" }
const _hoisted_8 = { class: "select-list" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "title-wrap" }
const _hoisted_11 = { class: "buttons-wrap" }
const _hoisted_12 = {
  key: 0,
  class: "statuses-wrap"
}
const _hoisted_13 = { class: "select-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Typography = _resolveComponent("Typography")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Hint = _resolveComponent("Hint")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_DropdownList = _resolveComponent("DropdownList")!
  const _component_Badge = _resolveComponent("Badge")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.softphoneParameters.status !== 'connected' || _ctx.currentComponent === 'SignUp')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Typography, { class: "title" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('header')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Select, {
              class: "lang-select",
              modelValue: _ctx.activeLang,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeLang) = $event)),
              size: "s",
              options: _ctx.languages,
              transparent: true
            }, null, 8, ["modelValue", "options"]),
            (_ctx.appConfig.IS_PLATFORM_INTEGRATED)
              ? (_openBlock(), _createBlock(_component_Hint, {
                  key: 0,
                  class: "tooltip",
                  text: _ctx.t('hints.buttonClose')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Button, {
                      class: "button-close",
                      iconOnly: "",
                      size: "m",
                      icon: {name: 'ic20-close', color: '--sui-gray-400'},
                      onClick: _ctx.logoutFx
                    }, null, 8, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["text"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (!_ctx.settingsState.minimize)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_Typography, { class: "user-name" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.userName), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Typography, { class: "user-id" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.userID), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_Hint, {
                    class: "tooltip",
                    text: _ctx.t('hints.buttonsSettings')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Button, {
                        class: "user-settings",
                        iconOnly: "",
                        size: "m",
                        ref: "moreActionsBtn",
                        icon: {name: 'ic20-more-ver', color: '--sui-gray-400'},
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleActionsDropdownList(!_ctx.isOpenMoreActions)))
                      }, null, 512)
                    ]),
                    _: 1
                  }, 8, ["text"]),
                  _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                      (_ctx.isOpenMoreActions)
                        ? (_openBlock(), _createBlock(_component_DropdownList, {
                            key: 0,
                            class: "more-actions-dropdown"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("ul", _hoisted_8, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moreActionsList, (action) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    class: "list-item",
                                    onClick: action.click
                                  }, [
                                    (action.icon)
                                      ? (_openBlock(), _createBlock(_component_Icon, {
                                          key: 0,
                                          color: action.icon.color,
                                          name: action.icon.name,
                                          width: "20",
                                          height: "20"
                                        }, null, 8, ["color", "name"]))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_Typography, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(action.name), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ], 8, _hoisted_9))
                                }), 256))
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              (_ctx.showActiveCamIcon)
                ? (_openBlock(), _createBlock(_component_Icon, {
                    key: 0,
                    class: "icon-using-of-cam",
                    color: "--sui-red-500",
                    spriteUrl: "static/icons-pack.svg",
                    name: "ic16-using-of-cam",
                    width: "16",
                    height: "16"
                  }))
                : _createCommentVNode("", true),
              (_ctx.minimizeTitle)
                ? (_openBlock(), _createBlock(_component_Typography, {
                    key: 1,
                    class: "user-name"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.minimizeTitle), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_Hint, {
                class: "tooltip",
                text: _ctx.settingsState.minimize ? _ctx.t('hints.buttonMaximize') : _ctx.t('hints.buttonMinimize')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Button, {
                    class: "collapse",
                    iconOnly: "",
                    size: "m",
                    icon: _ctx.getMinimizeIcon,
                    onClick: _ctx.toggleMinimize
                  }, null, 8, ["icon", "onClick"])
                ]),
                _: 1
              }, 8, ["text"]),
              (!_ctx.appConfig.AUDIO_ONLY)
                ? (_openBlock(), _createBlock(_component_Hint, {
                    key: 0,
                    class: "tooltip",
                    text: _ctx.settingsState.maximize ? _ctx.t('hints.buttonCollapse') : _ctx.t('hints.buttonFullscreen')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Button, {
                        class: "collapse",
                        iconOnly: "",
                        size: "m",
                        icon: _ctx.getMaximizeIcon,
                        onClick: _ctx.toggleMaximize
                      }, null, 8, ["icon", "onClick"])
                    ]),
                    _: 1
                  }, 8, ["text"]))
                : _createCommentVNode("", true),
              (_ctx.appConfig.IS_PLATFORM_INTEGRATED)
                ? (_openBlock(), _createBlock(_component_Hint, {
                    key: 1,
                    class: "tooltip",
                    text: _ctx.t('hints.buttonClose')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Button, {
                        class: "button-close",
                        iconOnly: "",
                        size: "m",
                        icon: {name: 'ic20-close', color: '--sui-gray-400'},
                        onClick: _ctx.logoutFx
                      }, null, 8, ["onClick"])
                    ]),
                    _: 1
                  }, 8, ["text"]))
                : _createCommentVNode("", true)
            ])
          ]),
          (!_ctx.settingsState.minimize && _ctx.signInStore.queueType !== _ctx.QueueType.None)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (_ctx.isBannedStatus)
                  ? (_openBlock(), _createBlock(_component_Badge, {
                      key: 0,
                      class: "badge",
                      size: "m",
                      backgroundColor: "--sui-red-500",
                      color: "white",
                      label: _ctx.t('statuses.banned')
                    }, null, 8, ["label"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_13, [
                  (_ctx.signInStore.queueType !== _ctx.QueueType.None)
                    ? (_openBlock(), _createBlock(_component_Select, {
                        key: 0,
                        class: "select-statuses",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = (status) => _ctx.changeQueueStatus(status.value)),
                        modelValue: _ctx.currentStatus,
                        size: "s",
                        options: _ctx.signInStore.queueType === _ctx.QueueType.SmartQueue ? _ctx.statusesSq : _ctx.statuses,
                        transparent: true,
                        placeholder: _ctx.t('statuses.placeholder')
                      }, null, 8, ["modelValue", "options", "placeholder"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}